const serverUrl = process.env.PENTA_MASTER_SERVER_URL || `https://${window.location.hostname}/api/`;

export const LOCATIONS_GET_DEPARTMENTS = serverUrl + 'general/locations/get-departments';
export const LOCATIONS_GET_PROVINCES = serverUrl + 'general/locations/get-provinces/';
export const LOCATIONS_GET_DISTRICTS = serverUrl + 'general/locations/get-districts/';
export const CURRENCY_EXCHANGE_RATE = serverUrl +  'general/currency/exchange-rate/';

export const MASTER_TABLES = serverUrl + 'general/reports/master-tables/';